<template>
  <v-container class="pa-0">
    <v-row wrap class="mx-0">
      <v-col class="black--text">
        Total Premium: {{ formattedTotalPremium }}
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col cols="12" class="py-1">
        <v-hover v-slot:default="{ hover }">
          <v-card :elevation="hover ? 8 : 2" color="blue5" @click="showEndorsementsDialog = true">
            <v-card-title style="white-space:pre;" class="subtitle-1">
              <span>Endorsements</span>
            </v-card-title>
            <v-card-subtitle>
              <span>Total Premium: {{ formattedEndorsementsPremium }} </span>
            </v-card-subtitle>
          </v-card>
        </v-hover>
        </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col cols="12" class="py-1">
        <v-hover v-slot:default="{ hover }">
          <v-card :elevation="hover ? 8 : 2" color="blue5" @click="showScheduleItemsDialog = true">
            <v-card-title style="white-space:pre;" class="subtitle-1">
              <span>Scheduled Property </span>
            </v-card-title>
            <v-card-subtitle>
              <span>Total Premium: {{ formattedScheduledPropertyPremium }} </span>
            </v-card-subtitle>
          </v-card>
        </v-hover>
        </v-col>
    </v-row>
    <SmallTableCard
      title="Coverages"
      :items="coverages"
      three-column
      :headers="['Limit', 'Premium']"
      :fields="[ { name: 'name', type: ''}, { name: 'limits', type: ''}, { name: 'premium', type: 'currency'} ]" />
    <SmallTableCard
      title="Deductibles"
      :items="deductibles"
      three-column
      :headers="['Limit', 'Premium']"
      :fields="[ { name: 'name', type: ''}, { name: 'deductibles', type: ''}, { name: 'premium', type: 'currency'} ]" />
    <SmallTableCard
      title="Credits/Surcharges"
      :items="creditsAndSurcharges"
      two-column
      :headers="['Premium']"
      :fields="[ { name: 'name', type: ''}, { name: 'premium', type: 'currency'} ]" />
    <v-dialog v-model="showScheduleItemsDialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
      <HomeScheduledProperty :client-id="clientId" :policy-order-number="policyOrderNumber" @closeScheduledItemsDialog="showScheduleItemsDialog = false" />
    </v-dialog>
    <v-dialog v-model="showEndorsementsDialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
      <HomeEndorsements :client-id="clientId" :policy-order-number="policyOrderNumber" @closeEndorsementsDialog="showEndorsementsDialog = false" />
    </v-dialog>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading coverages...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
</style>

<script>
import { mapActions } from 'vuex';
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import apiService from '@/services/shared/agentPortalApiService.js';
import coverageTranslator from '@/services/clientViewer/coverageTranslator.js';
import SmallTableCard from '@/components/Shared/SmallTableCard.vue';
import HomeScheduledProperty from '@/components/Client/Policies/Home/HomeScheduledProperty.vue';
import HomeEndorsements from '@/components/Client/Policies/Home/HomeEndorsements.vue';

export default {
  name: 'HomeCoverages',
  components: { SmallTableCard, HomeScheduledProperty, HomeEndorsements },
  props: {
    lob: {
      type: Boolean,
      required: false
    },
    policy: {
      type: Boolean,
      required: false
    }
  },
  data: function () {
    return {
      coverageInfo: null,
      showScheduleItemsDialog: false,
      showEndorsementsDialog: false
    };
  },
  computed: {
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    formattedTotalPremium: function () {
      if ((this.coverageInfo || null) === null) {
        return 0;
      }
      return displayFormatterService.formatCurrency(this.coverageInfo.totalPremium);
    },
    formattedEndorsementsPremium: function () {
      if ((this.coverageInfo || null) === null) {
        return 0;
      }
      return displayFormatterService.formatCurrency(this.coverageInfo.endorsementTotalPremium);
    },
    formattedScheduledPropertyPremium: function () {
      if ((this.coverageInfo || null) === null) {
        return 0;
      }
      return displayFormatterService.formatCurrency(this.coverageInfo.scheduledPropertyTotalPremium);
    },
    coverages: function () {
      if ((this.coverageInfo || null) === null) {
        return [];
      }
      return this.coverageInfo.coverages;
    },
    deductibles: function () {
      if ((this.coverageInfo || null) === null) {
        return [];
      }
      return this.coverageInfo.deductibles;
    },
    creditsAndSurcharges: function () {
      if ((this.coverageInfo || null) === null) {
        return [];
      }
      return this.coverageInfo.creditsAndSurcharges;
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getHomeCoverages(this.clientId, this.policyOrderNumber);
    if (rs.code === 0) {
      if (rs.data.length === 0) this.coverageInfo = {};

      this.coverageInfo = coverageTranslator.translateHomeCoverages(rs.data[0]);
    } else {
      this.error = true;
      this.setError(rs.message);
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
